import React from 'react'
import { useParams, useRouteMatch } from 'react-router-dom'
import BlogView from 'src/apps/Blog/apps/View'
import DiscussionView from 'src/apps/Discussions/apps/View'
import InitiativeView from 'src/apps/Initiative/apps/View'
import ResourceView from 'src/apps/Resources/apps/View'
import { useInitiative } from 'src/graphql/hooks'
import { InitiativeHierarchyProvider } from 'src/libraries/contexts/InitiativeHierarchy'

const Initiative = () => {
   const match = useRouteMatch()
   const { initiativeSlug } = useParams()

   const initiativeFilter = {}
   if (match.url.startsWith('/initiatives')) {
      initiativeFilter.slug = initiativeSlug
   } else {
      initiativeFilter.url = match.url.substring(1)
   }

   const { initiative, networkStatus, refetch } = useInitiative(initiativeFilter)
   if (networkStatus <= 2) {
      return null
   }

   const isUrlOrFilesResource = initiative.class === 'resource' &&
      ['url', 'files'].includes(initiative.resourceFormat)

   if (initiative.class === 'post') {
      return <BlogView />
   }

   if (initiative.class === 'discussion') {
      return <DiscussionView />
   }

   if (isUrlOrFilesResource) {
      return <ResourceView />
   }

   return (
      <InitiativeHierarchyProvider
         initiative={initiative}
         refetchInitiative={refetch}>
         <InitiativeView />
      </InitiativeHierarchyProvider>
   )
}

export default Initiative
